










import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },

    props: {
        packs: {
            type: Array,
            required: true,
        },
    },

    computed: {
        options: function() {
            const packs = this.packs as string[];
            return packs.map(pack => ({
                "label": pack.charAt(0).toUpperCase() + pack.slice(1).toLowerCase(),
                "value": pack,
            }));
        },
    },

    methods: {
        selectPack: function (pack: string) {
            this.$emit("pack-select", pack);
        },
    }
});
